import { Link, useLocation } from "react-router-dom";
import useSeo from "../lib/useSeo";
import { EMAIL } from "../lib/site";

const PAGES = {
  "/privacy-policy": { title: "Privacy Policy", body: [
    "When you submit an enquiry, we collect the details you provide (name, phone, email, travel preferences and message) so that our team can respond and plan your trip.",
    "Your details are stored securely and are only accessible to authorised Wandervibe staff. We do not sell your personal information.",
    `To request access to or deletion of your data, email ${EMAIL}.`,
  ] },
  "/terms-and-conditions": { title: "Terms & Conditions", body: [
    "Submitting an enquiry on this website does not confirm a booking. Bookings are confirmed only after written confirmation from Wandervibe Journeys.",
    "Itineraries may change because of weather, road conditions, government regulations or other circumstances outside our control.",
    "[Placeholder — full booking terms to be provided by Wandervibe Journeys.]",
  ] },
  "/cancellation-policy": { title: "Cancellation Policy", body: [
    "Cancellation terms depend on the trip and are shared with you in writing before you pay.",
    "[Placeholder — full cancellation and refund policy to be provided by Wandervibe Journeys.]",
  ] },
};

export default function Policy() {
  const { pathname } = useLocation();
  const p = PAGES[pathname];
  useSeo({ title: `${p.title} | Wandervibe Journeys`, description: `${p.title} for Wandervibe Journeys.`, path: pathname });
  return (
    <section className="container-x max-w-3xl py-16 md:py-24" data-testid="policy-page">
      <h1 className="text-4xl sm:text-5xl">{p.title}</h1>
      <div className="mt-8 space-y-4 text-base leading-relaxed text-slate-700">{p.body.map((b) => <p key={b}>{b}</p>)}</div>
      <Link to="/contact-us" className="btn-brand mt-10">Contact Us</Link>
    </section>
  );
}

export function NotFound() {
  useSeo({ title: "Page not found | Wandervibe Journeys", description: "", path: "/404", noindex: true });
  return (
    <section className="container-x py-32 text-center" data-testid="not-found-page">
      <h1 className="text-4xl sm:text-5xl">This trail doesn't exist</h1>
      <p className="mt-4 text-slate-600">The page you're looking for couldn't be found.</p>
      <Link to="/" className="btn-brand mt-8">Back to Home</Link>
    </section>
  );
}
